import { render, staticRenderFns } from "./task-modal.vue?vue&type=template&id=461c1e6c&scoped=true&lang=pug&"
import script from "./task-modal.vue?vue&type=script&lang=js&"
export * from "./task-modal.vue?vue&type=script&lang=js&"
import style0 from "./task-modal.vue?vue&type=style&index=0&id=461c1e6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c1e6c",
  null
  
)

export default component.exports